export default "__VITE_ASSET__CcbsLU$N__"